//
//
//
//
//
//

import i18n from "@/utils/i18n";
export default {
  name: "min-editor",
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  computed: {
    minValue: {
      get: function get() {
        return this.optionModel['min'];
      },
      set: function set(newValue) {
        //if ((!newValue && (newValue !== 0)) || isNaN(newValue)) {
        if (newValue === undefined || newValue === null || isNaN(newValue)) {
          this.optionModel.min = null;
        } else {
          this.optionModel.min = Number(newValue);
        }
      }
    }
  }
};